import { useParams } from "react-router-dom";
// let tokk = "1";
const PowerBiLinkPage = () => {
  const location = useParams();
  // const [embedConfig, setEmbedConfig] = useState({
  //   type: "report",
  //   id: "6b0342c5-757f-4e35-865e-87b0887d1435",
  //   embedUrl:
  //     "https://app.powerbi.com/reportEmbed?reportId=6b0342c5-757f-4e35-865e-87b0887d1435&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUYtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsInVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d",
  //   accessToken: `${tokk}`, // Use the updated 'tokk' value
  //   tokenType: models.TokenType.Embed,
  //   settings: {
  //     panes: {
  //       filters: {
  //         expanded: false,
  //         visible: false,
  //       },
  //       visible: false,
  //     },
  //   },
  // });
  // const workspaceId = "me"; // Power BI workspace ID
  // const reportId = "98482cc5-1219-459b-9f9a-b24c2f203343"; // Power BI report ID

  // // Authenticate with Azure AD to get a token
  // const authenticateAzureAD = async () => {
  //   const tokenUrl = "https://login.microsoftonline.com/common/oauth2/token";

  //   const data = {
  //     grant_type: "password",
  //     client_id: clientId,
  //     client_secret: clientSecret,
  //     scope: "openid",
  //     resource: "https://analysis.windows.net/powerbi/api",
  //     username: "mh@spatialox.com", // Replace with your username
  //     password: "Simplyinnotime346901@", // Replace with your password
  //   };

  //   try {
  //     const response = await axios.post(tokenUrl, new URLSearchParams(data), {
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //     });

  //     return response.data.access_token;
  //   } catch (error) {
  //     console.error("Azure AD authentication error:", error);
  //     throw error;
  //   }
  // };
  // , "defdefdedwssefwdsw");
  // const generateEmbedToken = async () => {
  //   const accessToken = await authenticateAzureAD();
  //   const apiUrl = `https://api.powerbi.com/v1.0/myorg/groups/${workspaceId}/reports/${reportId}/GenerateToken`;

  //   const data = {
  //     accessLevel: "View",
  //   };

  //   try {
  //     const response = await axios.post(apiUrl, data, {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     });

  //     return response.data.token;
  //   } catch (error) {
  //     console.error("Power BI token generation error:", error);
  //     throw error;
  //   }
  // };

  // const wow = generateEmbedToken();
  //
  // Example API endpoint for token refresh
  // app.post("/refresh-token", async (req, res) => {
  //   try {
  //     const embedToken = await generateEmbedToken();
  //     res.json({ accessToken: embedToken });
  //   } catch (error) {
  //     res.status(500).json({ error: "Token refresh failed" });
  //   }
  // });

  // const ww = async () => {
  //   // wow = await report.setAccessToken(
  //   //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvNjI1M2YwYzEtYjQyMy00Nzc2LWFlNTktMDk0NjgzYzNhNzZiLyIsImlhdCI6MTY5NDY4MjkzNSwibmJmIjoxNjk0NjgyOTM1LCJleHAiOjE2OTQ2ODgzMTAsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVFFBeS84VUFBQUFhS2c1NHMvQWpxTEljbDY4WkF6OExVK3p6WUhSOXYrVytiSUM3enEzdnhvazF3aVdKd2F6SGJnK1puQ0RYM1pJIiwiYW1yIjpbInB3ZCJdLCJhcHBpZCI6Ijg3MWMwMTBmLTVlNjEtNGZiMS04M2FjLTk4NjEwYTdlOTExMCIsImFwcGlkYWNyIjoiMiIsImZhbWlseV9uYW1lIjoiS2hhbiIsImdpdmVuX25hbWUiOiJBYmR1bGxhaCIsImlwYWRkciI6IjM5LjQ0LjEzOC4xNTYiLCJuYW1lIjoiQWJkdWxsYWggS2hhbiIsIm9pZCI6IjViOThiN2NlLTU3NjItNDE5My05ZjEwLWZjOTI4NmQ2M2Q4ZiIsInB1aWQiOiIxMDAzMjAwMkYxOEI5RDM4IiwicmgiOiIwLkFhOEF3ZkJUWWlPMGRrZXVXUWxHZzhPbmF3a0FBQUFBQUFBQXdBQUFBQUFBQUFDdkFKay4iLCJzY3AiOiJ1c2VyX2ltcGVyc29uYXRpb24iLCJzdWIiOiJTM0pDQUlXVTlXOFBQWXFxQ28tb3pDOFR2a0VJeUhxYllBXzBjQjFXTUVJIiwidGlkIjoiNjI1M2YwYzEtYjQyMy00Nzc2LWFlNTktMDk0NjgzYzNhNzZiIiwidW5pcXVlX25hbWUiOiJtaEBzcGF0aWFsb3guY29tIiwidXBuIjoibWhAc3BhdGlhbG94LmNvbSIsInV0aSI6IkgweUJzczNsUDA2SHJpaDJwYUVTQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfcGwiOiJlbi1VUyJ9.kbDBiKS0v45paIxosIIuW73BeX_TMKkzz-ae-D7vYM883KcfEC-Amxxq4evXDLMHHugGF0PDLYeh94njpZwZsiI61R-6duDYc0V0-2W9wi0gQSDE6RYssZtXTus2VCpmt3H9D60Mpi1UCwWremrEQBf58sBhAvTbyy7iQR9Hpg-Wz74-LQRnHqnkmPCeCnO0s4g57_evSSWCPAJWijVv22j4nkkXi7UOpOj0wE2qNmVE_OmLQMdzSXmOcB56iska_YYXTdERV4F-T_P68lC8Rn_KZwE2lbrKRKpjVaj6jEQee-QxeHlncIOKDLk9dn6Edzy_bp4T-EZ5Uknzi3PGYA"
  //   // );
  //   wow = await getNewUserAccessToken(
  //     "98482cc5-1219-459b-9f9a-b24c2f203343",
  //     "me"
  //   );
  // };
  // ww();
  // useEffect(() => {
  //
  // }, [wow]);

  // const clientId = "2193afa0-4f5f-420b-a645-9dae7a364c00";
  // const clientSecret = "wqwq";
  // const resource = "https://analysis.windows.net/powerbi/api";

  // const getToken = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://login.microsoftonline.com/common/oauth2/token",
  //       {
  //         grant_type: "password",
  //         client_id: clientId,
  //         client_secret: clientSecret,
  //         resource: resource,
  //         username: "mh@spatialox.com",
  //         password: "Simplyinnotime346901@",
  //       }
  //     );

  //     const accessToken = response.data.access_token;
  //     const refreshToken = response.data.refresh_token;

  //     // Store the accessToken and refreshToken securely in your app.
  //     // You may use local storage or a state management library like Redux.

  //     return accessToken;
  //   } catch (error) {
  //     console.error("Error obtaining initial token:", error);
  //     throw error;
  //   }
  // };

  // getToken();
  // let getNewAccessToken = async function () {
  //   axios
  //     .post(
  //       "https://api.powerbi.com/v1.0/myorg/GenerateToken",
  //       {
  //         datasets: [
  //           {
  //             id: "dea8e0d6-d1ce-429d-a77e-c69e44189ba3",
  //           },
  //         ],
  //         reports: [
  //           {
  //             id: "6b0342c5-757f-4e35-865e-87b0887d1435",
  //           },
  //         ],

  //         lifetimeInMinutes: 10,
  //       },
  //       {
  //         headers: {
  //           Authorization:
  //             "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSIsImtpZCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvNjI1M2YwYzEtYjQyMy00Nzc2LWFlNTktMDk0NjgzYzNhNzZiLyIsImlhdCI6MTY5ODM5NDQ1NCwibmJmIjoxNjk4Mzk0NDU0LCJleHAiOjE2OTgzOTkzNjMsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVlFBcS84VUFBQUFJNmhTeG92RDZESUs4TkExbGJ1d3pEL0s3SEtXUWNKVWhMaWhuV2NXOWRwRCs4aFZtWDdNNU1hU2JHalIrd3phK1ZqZXZiaTYrN2UrTEpXakd0akY1K1AvTzNQOGtOTWNsRGpUcXRIMWZ1dz0iLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcGlkIjoiMThmYmNhMTYtMjIyNC00NWY2LTg1YjAtZjdiZjJiMzliM2YzIiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJLaGFuIiwiZ2l2ZW5fbmFtZSI6IkFiZHVsbGFoIiwiaXBhZGRyIjoiMjQwMDphZGNjOjE1YTo5ODAwOmQ5YmY6MmM0Njo1OTQ4OjJhZDEiLCJuYW1lIjoiQWJkdWxsYWggS2hhbiIsIm9pZCI6IjViOThiN2NlLTU3NjItNDE5My05ZjEwLWZjOTI4NmQ2M2Q4ZiIsInB1aWQiOiIxMDAzMjAwMkYxOEI5RDM4IiwicmgiOiIwLkFhOEF3ZkJUWWlPMGRrZXVXUWxHZzhPbmF3a0FBQUFBQUFBQXdBQUFBQUFBQUFDdkFKay4iLCJzY3AiOiJBcHAuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZFdyaXRlLkFsbCBDb250ZW50LkNyZWF0ZSBEYXNoYm9hcmQuUmVhZC5BbGwgRGFzaGJvYXJkLlJlYWRXcml0ZS5BbGwgRGF0YWZsb3cuUmVhZC5BbGwgRGF0YWZsb3cuUmVhZFdyaXRlLkFsbCBEYXRhc2V0LlJlYWQuQWxsIERhdGFzZXQuUmVhZFdyaXRlLkFsbCBHYXRld2F5LlJlYWQuQWxsIEdhdGV3YXkuUmVhZFdyaXRlLkFsbCBQaXBlbGluZS5EZXBsb3kgUGlwZWxpbmUuUmVhZC5BbGwgUGlwZWxpbmUuUmVhZFdyaXRlLkFsbCBSZXBvcnQuUmVhZC5BbGwgUmVwb3J0LlJlYWRXcml0ZS5BbGwgU3RvcmFnZUFjY291bnQuUmVhZC5BbGwgU3RvcmFnZUFjY291bnQuUmVhZFdyaXRlLkFsbCBUZW5hbnQuUmVhZC5BbGwgVGVuYW50LlJlYWRXcml0ZS5BbGwgVXNlclN0YXRlLlJlYWRXcml0ZS5BbGwgV29ya3NwYWNlLlJlYWQuQWxsIFdvcmtzcGFjZS5SZWFkV3JpdGUuQWxsIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiUzNKQ0FJV1U5VzhQUFlxcUNvLW96QzhUdmtFSXlIcWJZQV8wY0IxV01FSSIsInRpZCI6IjYyNTNmMGMxLWI0MjMtNDc3Ni1hZTU5LTA5NDY4M2MzYTc2YiIsInVuaXF1ZV9uYW1lIjoibWhAc3BhdGlhbG94LmNvbSIsInVwbiI6Im1oQHNwYXRpYWxveC5jb20iLCJ1dGkiOiJnSWNXM3JLVG9VR202VkI1YzlBeEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3BsIjoiZW4tVVMifQ.hxwDhSHZs9uZ1Dyw_TPBtfwpDQmosRvMfm_lPiOtdh0sFfYe28u1jWgobYmujn0whl2oi6_HZU3aLppRa_Cq8iq8jjYSJLgb6WjSydCOv0l3g_-b_wVebQoibZmAIYWK9NobOJOoitPsu65hHOTyaXzePDhi6brk2ty1kRG9JkiKG3f8i2WlMXHNLq5ZK1FD1irB6vIS7cxFsRT6RnqGcEclyW9n8T64bsTnbp7P8ZMREB3Fw_iKQLmVpr2Yugp3Y1UzfrISMhuR-CiCnl9c8VtBIIX9LRDKM-Hs39rNqEPnc-aO7_deYCJHOm8a6uGJrTSnKGgUgvEImyBIcDC0Dg",
  //         },
  //       }
  //     )
  //     .then((data) => {
  //       setTokk(data.data.token);
  //     })
  //     .catch((err) => {});
  // };

  // useEffect(() => {
  //   axios
  //     .post(
  //       "https://api.powerbi.com/v1.0/myorg/GenerateToken",
  //       {
  //         datasets: [
  //           {
  //             id: "dea8e0d6-d1ce-429d-a77e-c69e44189ba3",
  //           },
  //         ],
  //         reports: [
  //           {
  //             id: "6b0342c5-757f-4e35-865e-87b0887d1435",
  //           },
  //         ],

  //         lifetimeInMinutes: 10,
  //       },
  //       {
  //         headers: {
  //           Authorization:
  //             "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSIsImtpZCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvNjI1M2YwYzEtYjQyMy00Nzc2LWFlNTktMDk0NjgzYzNhNzZiLyIsImlhdCI6MTY5ODM5NDQ1NCwibmJmIjoxNjk4Mzk0NDU0LCJleHAiOjE2OTgzOTkzNjMsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVlFBcS84VUFBQUFJNmhTeG92RDZESUs4TkExbGJ1d3pEL0s3SEtXUWNKVWhMaWhuV2NXOWRwRCs4aFZtWDdNNU1hU2JHalIrd3phK1ZqZXZiaTYrN2UrTEpXakd0akY1K1AvTzNQOGtOTWNsRGpUcXRIMWZ1dz0iLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcGlkIjoiMThmYmNhMTYtMjIyNC00NWY2LTg1YjAtZjdiZjJiMzliM2YzIiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJLaGFuIiwiZ2l2ZW5fbmFtZSI6IkFiZHVsbGFoIiwiaXBhZGRyIjoiMjQwMDphZGNjOjE1YTo5ODAwOmQ5YmY6MmM0Njo1OTQ4OjJhZDEiLCJuYW1lIjoiQWJkdWxsYWggS2hhbiIsIm9pZCI6IjViOThiN2NlLTU3NjItNDE5My05ZjEwLWZjOTI4NmQ2M2Q4ZiIsInB1aWQiOiIxMDAzMjAwMkYxOEI5RDM4IiwicmgiOiIwLkFhOEF3ZkJUWWlPMGRrZXVXUWxHZzhPbmF3a0FBQUFBQUFBQXdBQUFBQUFBQUFDdkFKay4iLCJzY3AiOiJBcHAuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZFdyaXRlLkFsbCBDb250ZW50LkNyZWF0ZSBEYXNoYm9hcmQuUmVhZC5BbGwgRGFzaGJvYXJkLlJlYWRXcml0ZS5BbGwgRGF0YWZsb3cuUmVhZC5BbGwgRGF0YWZsb3cuUmVhZFdyaXRlLkFsbCBEYXRhc2V0LlJlYWQuQWxsIERhdGFzZXQuUmVhZFdyaXRlLkFsbCBHYXRld2F5LlJlYWQuQWxsIEdhdGV3YXkuUmVhZFdyaXRlLkFsbCBQaXBlbGluZS5EZXBsb3kgUGlwZWxpbmUuUmVhZC5BbGwgUGlwZWxpbmUuUmVhZFdyaXRlLkFsbCBSZXBvcnQuUmVhZC5BbGwgUmVwb3J0LlJlYWRXcml0ZS5BbGwgU3RvcmFnZUFjY291bnQuUmVhZC5BbGwgU3RvcmFnZUFjY291bnQuUmVhZFdyaXRlLkFsbCBUZW5hbnQuUmVhZC5BbGwgVGVuYW50LlJlYWRXcml0ZS5BbGwgVXNlclN0YXRlLlJlYWRXcml0ZS5BbGwgV29ya3NwYWNlLlJlYWQuQWxsIFdvcmtzcGFjZS5SZWFkV3JpdGUuQWxsIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiUzNKQ0FJV1U5VzhQUFlxcUNvLW96QzhUdmtFSXlIcWJZQV8wY0IxV01FSSIsInRpZCI6IjYyNTNmMGMxLWI0MjMtNDc3Ni1hZTU5LTA5NDY4M2MzYTc2YiIsInVuaXF1ZV9uYW1lIjoibWhAc3BhdGlhbG94LmNvbSIsInVwbiI6Im1oQHNwYXRpYWxveC5jb20iLCJ1dGkiOiJnSWNXM3JLVG9VR202VkI1YzlBeEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3BsIjoiZW4tVVMifQ.hxwDhSHZs9uZ1Dyw_TPBtfwpDQmosRvMfm_lPiOtdh0sFfYe28u1jWgobYmujn0whl2oi6_HZU3aLppRa_Cq8iq8jjYSJLgb6WjSydCOv0l3g_-b_wVebQoibZmAIYWK9NobOJOoitPsu65hHOTyaXzePDhi6brk2ty1kRG9JkiKG3f8i2WlMXHNLq5ZK1FD1irB6vIS7cxFsRT6RnqGcEclyW9n8T64bsTnbp7P8ZMREB3Fw_iKQLmVpr2Yugp3Y1UzfrISMhuR-CiCnl9c8VtBIIX9LRDKM-Hs39rNqEPnc-aO7_deYCJHOm8a6uGJrTSnKGgUgvEImyBIcDC0Dg",
  //         },
  //       }
  //     )
  //     .then((data) => {
  //       const newEmbedConfig = {
  //         type: "report",
  //         id: "6b0342c5-757f-4e35-865e-87b0887d1435",
  //         embedUrl:
  //           "https://app.powerbi.com/reportEmbed?reportId=6b0342c5-757f-4e35-865e-87b0887d1435&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUYtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",
  //         accessToken: `${data.data.token}`, // Use the updated 'tokk' value
  //         tokenType: models.TokenType.Embed,
  //         settings: {
  //           panes: {
  //             filters: {
  //               expanded: false,
  //               visible: false,
  //             },
  //             visible: false,
  //           },
  //         },
  //       };
  //       setEmbedConfig(newEmbedConfig);
  //       setTokk(data.data.token);
  //     })
  //     .catch((err) => {});
  // }, []);
  // useEffect(() => {
  //   if (!test) {
  //     setTest(true);
  //   } else {
  //     setTest(false);
  //   }
  //   // window.location.reload();
  // }, [tokk]);
  // // getNewAccessToken();

  // useEffect(() => {
  //   // Create a new embedConfig with the updated token
  //   const newEmbedConfig = {
  //     type: "report",
  //     id: "6b0342c5-757f-4e35-865e-87b0887d1435",
  //     embedUrl:
  //       "https://app.powerbi.com/reportEmbed?reportId=6b0342c5-757f-4e35-865e-87b0887d1435&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUYtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",
  //     accessToken: `${tokk}`, // Use the updated 'tokk' value
  //     tokenType: models.TokenType.Embed,
  //     settings: {
  //       panes: {
  //         filters: {
  //           expanded: false,
  //           visible: false,
  //         },
  //         visible: false,
  //       },
  //     },
  //   };
  //   setEmbedConfig(newEmbedConfig);
  // }, [tokk]);

  // useEffect(() => {
  //   if (!test) {
  //     setTest(true);
  //   } else {
  //     setTest(false);
  //   }
  // }, [embedConfig]);
  return (
    <div className="">
      <div className="relative flex justify-start pl-[10rem] pr-[20rem] items-center text-[1.8rem] font-bold mb-[5rem]">
        {/* <div
          onClick={() => {
            router("/EDashboard");
          }}
          className="cursor-pointer pt-[5rem] mr-5"
        >
          <img className="w-[1.7rem]" src={back5} alt="" />
        </div> */}
        <h2 className="pt-[5rem]">Reports</h2>
      </div>
      {}
      <h2
        className={`mt-[4rem] text-center font-bold text-[3rem] ${
          location.id !== "1234" ? "" : "hidden"
        }`}
      >
        The Token is not valid or is expired
      </h2>
      {/* {tokk !== "1" && (
        <div
          className={`flex justify-center items-center mt-[3rem] mb-[3rem] ${
            location.id === "1234" ? "" : "hidden"
          }`}
        >
          <div className="scale-[1.3]">
            <PowerBIEmbed
              // embedConfig={{
              //   type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
              //   id: "6b0342c5-757f-4e35-865e-87b0887d1435",
              //   embedUrl:
              //     "https://app.powerbi.com/reportEmbed?reportId=6b0342c5-757f-4e35-865e-87b0887d1435&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUYtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsInVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d",
              //   accessToken: `${tokk}`,
              //   tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
              //   // eventHooks: {
              //   //   accessTokenProvider: getNewAccessToken,
              //   // },
              //   settings: {
              //     panes: {
              //       filters: {
              //         expanded: false,
              //         visible: false,
              //       },
              //       visible: false,
              //     },
              //   },
              // }}
              embedConfig={embedConfig}
              eventHandlers={
                new Map([
                  ["loaded", function () {}],
                  ["rendered", function () {}],
                  [
                    "error",
                    function (event) {
                      getNewAccessToken();
                    },
                  ],
                  ["visualClicked", () => {}],
                  ["pageChanged", (event) => {}],
                ])
              }
              cssClassName={"embeded-container"}
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
              }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default PowerBiLinkPage;
